import { isAxiosError } from "axios";

export type CardStatus =
	| "loading"
	| "error"
	| "forbidden"
	| "all-tenants-unavailable"
	| "empty"
	| "ready";

/** The server's reason for refusing a request, from its 403 body. */
const forbiddenReason = (error: unknown): string | undefined => {
	if (!isAxiosError(error) || error.response?.status !== 403) return undefined;
	const reason = error.response.data?.reason;
	return typeof reason === "string" ? reason : "forbidden";
};

/**
 * What a widget card shows for a query. Data already on screen stays visible
 * if a background refetch fails.
 */
export const cardStatus = <T>(
	query: { data: T | undefined; isError: boolean; error: unknown },
	isEmpty: (data: T) => boolean
): CardStatus => {
	if (query.data === undefined) {
		if (!query.isError) return "loading";
		const reason = forbiddenReason(query.error);
		// The server refuses "All tenants" when its master tenant setting is
		// missing or differs from the client's.
		if (reason === "all_tenants_not_allowed") return "all-tenants-unavailable";
		return reason ? "forbidden" : "error";
	}
	return isEmpty(query.data) ? "empty" : "ready";
};
